/**
* Function for sending form data to the server.
* @param {string} action - The action to be performed on the server.
* @param {FormData} formData - The FormData object containing the form data to be sent.
* @returns {Promise} - A Promise that resolves with the server's response or rejects with an error message.
*/
export function SendFormData(action, formData) {
	return new Promise(async (resolve, reject) => {
		// Create a request
		const httpRequest = new XMLHttpRequest();
		// Checking if the request exists
		if (!httpRequest) {
			reject('Giving up :( Cannot create an XMLHTTP instance');
			return;
		}
		httpRequest.open('POST', '/wp-admin/admin-ajax.php');
		httpRequest.onload = () => {
			if (httpRequest.status >= 200 && httpRequest.status < 300) {
				// If successful
				resolve(httpRequest.responseText);
			} else {
				// Connection error
				reject(httpRequest.statusText);
			}
		};
		httpRequest.onerror = () => {
			// Connection error
			reject(httpRequest.statusText);
		};
		// Add the action name and token to formData
		formData.append('action', action);
		// Send formData
		httpRequest.send(formData);
	});
}


// Field validation function
export const wclValidateField = (field) => {
	if (field.value.trim() === "") {
		field.classList.add('wcl-input-error');
		return false;
	} else {
		field.classList.remove('wcl-input-error');
		return true;
	}
};

export const wclValidateForm = (form) => {
	let isValid = true;
	const formInputs = form.querySelectorAll('.wcl-modal-form__input');
	formInputs.forEach(input => {
		if (!wclValidateField(input)) {
			isValid = false;
		}
	});
	return isValid;
};


/*
* Function for hiding an error when focusing on any of the fields in the form
*/
export function hideAlertMessageOnFocus(form, messageBlock) {
	// Get all elements with class .wcl-modal-form__input
	const inputs = form.querySelectorAll('.wcl-modal-form__input');

	//Check if messageBlock exists and if it has a class "show"
	if (messageBlock && messageBlock.classList.contains('show')) {
		// Go through each element and add a focus event handler
		inputs.forEach(function (input) {

			input.addEventListener('focus', function () {
				// Remove "show, error and success" classes from .wcl-message-alert element
				messageBlock.classList.remove('show', 'error', 'success');
			});

		});
	}
}


/*
* Function for clearing all errors and resetting the form
*/
export function resetConfirmCodeFormsAndClearErrors() {
	// Find all forms with class 'wcl-modal-form'
	const forms = document.querySelectorAll('.wcl-modal-confirm-code.wcl-modal-form');

	forms.forEach(function (form) {
		// Reset form
		form.reset();

		// Find all inputs with class 'wcl-modal-form__input'
		const inputs = form.querySelectorAll('.wcl-modal-form__input');

		inputs.forEach(function (input) {
			const errorBlock = input.nextElementSibling;

			if (errorBlock) {
				const errorText = errorBlock.querySelector('.wcl-error-message');

				if (input.classList.contains('wcl-input-error')) {
					input.classList.remove('wcl-input-error');
					errorBlock.classList.remove('show');

					if (errorText) {
						errorText.textContent = '';
					}
				}
			}
		});

		// Find message block by class 'wcl-message-alert'
		const messageBlock = form.querySelector('.wcl-message-alert');
		if (messageBlock) {
			const message = messageBlock.querySelector('.wcl-message');

			// Delete classes 'show', 'error', 'success'
			messageBlock.classList.remove('show', 'error', 'success');

			if (message) {
				message.textContent = '';
			}
		}

		// Find a block with the class 'wcl-error-confirm-code'
		const confirmCodeBlock = form.querySelector('.wcl-error-confirm-code');
		if (confirmCodeBlock) {
			confirmCodeBlock.textContent = '';
		}
	});
}

/*
* Function for setting cookies
*/
export function setCookie(key, value, days) {
	const expirationDate = new Date();
	expirationDate.setDate(expirationDate.getDate() + days);
	const cookieValue = encodeURIComponent(value) + (days ? `; expires=${expirationDate.toUTCString()}` : '');
	document.cookie = `${key}=${cookieValue}; path=/`;
}

/*
* Function to get the value of the cookie
*/
export function getCookie(key) {
	const name = `${key}=`;
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();
		if (cookie.indexOf(name) === 0) {
			return decodeURIComponent(cookie.substring(name.length, cookie.length));
		}
	}
	return null;
}